import { render } from "./EditorFontSelection.vue?vue&type=template&id=d1c982f4"
import script from "./EditorFontSelection.vue?vue&type=script&lang=js"
export * from "./EditorFontSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__